var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemHamburgerMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M20.1 17c.397 0 .9.447.9 1s-.503 1-.9 1H3.9c-.397 0-.9-.447-.9-1s.503-1 .9-1Zm0-6c.397 0 .9.447.9 1s-.503 1-.9 1H3.9c-.397 0-.9-.447-.9-1s.503-1 .9-1Zm0-6c.397 0 .9.447.9 1s-.503 1-.9 1H3.9C3.503 7 3 6.553 3 6s.503-1 .9-1Z"
})));
export default SvgGemHamburgerMenu;